export interface Lender {
    _id: string;
    bank_account: string;
    wallet: {amount: number};
}

export enum LenderApplicationStatus {
    READY_FOR_KYC = 'ready_for_kyc',
    KYC_IN_PROGRESS = 'kyc_in_progress',
    PENDING = 'pending',
    INVESTED = 'invested',
    VERIFIED = 'verified',
}

export interface LenderBasicInfo {
    id: string,
    walletAmount: number,
    virtualAccountNumber: string,
    lenderApplicationStatus: LenderApplicationStatus,
    portfolioPresent: boolean //TODO correct name.
}
